import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '$store/rootReducer';
import { PromoCodeState, SetPromoCodeAuthCodeAction } from './interface';

const initialState: PromoCodeState = {
  authCode: null,
};

export const { actions, reducer } = createSlice({
  name: 'promoCode',
  initialState,
  reducers: {
    setAuthCode(state, action: SetPromoCodeAuthCodeAction) {
      state.authCode = action.payload;
    },
    clearAuthCode(state) {
      state.authCode = null;
    },
  },
});

export { reducer as promoCodeReducer, actions as promoCodeActions };

export const promoCodeSelector = (state: RootState) => state.promoCode;
